<template>
  <div>
    <div class="bilList" @click="onClick">
      <van-icon class-prefix="icon" class="iconfont" name="purse"></van-icon>
      <div style="flex-grow:1;">
        <div class="first">
          <span style="font-size:.22rem;">{{ title }}</span>
          <span style="font-size:.28rem;" :style="{color: paid ? '#07c160' : '#3f8aec'}">
            {{ paid ? '已还清' : '待还款' }}
          </span>
        </div>
        <p style="font-size:.48rem;color:#fe5f5f;line-height:.7rem">¥{{ amountText }}</p>
        <p style="font-size:.24rem">
          {{ paid ? '还款时间' : '应还日期' }}
          <strong>{{ dateText }}</strong>
        </p>
      </div>
      <van-button
        v-if="!paid && showPay"
        size="mini"
        round
        color="linear-gradient(to right,#6aa8f5, #3d8aef)"
        :loading="loading"
        @click.stop="onPay"
      >还款</van-button>
    </div>

    <van-action-sheet v-model="showSheet" title="选择还款渠道">
      <div class="sheet">
        <van-radio-group v-model="channel">
          <van-cell-group>
            <van-cell
              v-for="item in channels"
              :key="item.code"
              :title="item.name"
              :label="channelLabel(item)"
              clickable
              @click="channel = item.code"
            >
              <template #right-icon>
                <van-radio :name="item.code" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <van-button
          round
          block
          color="linear-gradient(to right,#6aa8f5, #3d8aef)"
          style="margin-top:16px"
          :loading="loading"
          :disabled="!channel"
          @click="confirmPay"
        >去支付 ¥{{ amountText }}</van-button>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { repayBill, payChannels } from '@/api/request.js'

export default {
  props: {
    billist: { type: Object, required: true },
    showPay: { type: Boolean, default: true }
  },
  data() {
    return {
      loading: false,
      showSheet: false,
      channels: [],
      channel: ''
    }
  },
  computed: {
    paid() {
      return this.billist.status === 'paid' || this.billist.repaymentStatus == 2
    },
    title() {
      if (this.billist.period) return `第${this.billist.period}期 · ${this.billist.product_name || '借款'}`
      return this.billist.product_name || '借款'
    },
    amountText() {
      const n = this.paid
        ? (this.billist.paid_amount || this.billist.amount || this.billist.repaymentNum || 0)
        : ((this.billist.amount || 0) - (this.billist.paid_amount || 0) || this.billist.repaymentNum || 0)
      return Number(n).toFixed(2)
    },
    dateText() {
      return this.billist.paid_at || this.billist.due_date || this.billist.repaymentTime || '-'
    }
  },
  methods: {
    channelHint(code) {
      if (code === 'bank' || String(code || '').startsWith('bank')) return '银行卡转账'
      if (code === 'wechat') return '扫码支付'
      if (code === 'alipay') return '扫码支付'
      return ''
    },
    channelLabel(c) {
      const d = (c && c.display) || {}
      if (d.type === 'bank' || c.mode === 'bank') {
        const parts = []
        if (d.bankName) parts.push(d.bankName)
        if (d.accountName) parts.push(`户名 ${d.accountName}`)
        if (d.accountNo) parts.push(d.accountNo)
        if (d.branch) parts.push(d.branch)
        if (parts.length) return parts.join(' · ')
      }
      if (d.type === 'qr' && d.payeeName) return `收款人 ${d.payeeName}`
      return c.remark || this.channelHint(c.code)
    },
    onClick() {
      this.$emit('select', this.billist)
    },
    async onPay() {
      this.loading = true
      try {
        const res = await payChannels()
        const data = res.data || {}
        this.channels = data.list || []
        this.channel = data.defaultChannel || (this.channels[0] && this.channels[0].code) || ''
        if (!this.channels.length) {
          Toast('暂无可用还款渠道，请联系管理员配置')
          return
        }
        this.showSheet = true
      } finally {
        this.loading = false
      }
    },
    async confirmPay() {
      this.loading = true
      try {
        const res = await repayBill(this.billist.id, { channel: this.channel })
        const data = res.data || {}
        this.showSheet = false
        if (data.payUrl) {
          window.location.href = data.payUrl
          return
        }
        Toast.success(data.message || '已提交')
        this.$emit('paid', this.billist)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.bilList{
  margin: 0 .24rem;
  background: #fff;
  border-radius: .2rem;
  min-height: 2.08rem;
  display: flex;
  justify-content: space-between;
  padding: .3rem;
  box-shadow: 3px 3px 30px #ddd;
  align-items: center;
  margin-top: .3rem;
  .iconfont{
    background: #4b96f0;
    color: #fff;
    height: .72rem;
    border-radius: 50%;
    width: .72rem;
    text-align: center;
    line-height: .72rem;
    font-size: 0.4rem;
    margin-right: .28rem;
    flex-shrink: 0;
  }
  .first{
    display: flex;
    justify-content: space-between;
  }
}
.sheet {
  padding: 8px 16px 24px;
}
</style>
